<template>
  <div class="product-page quantity-offers">
    <div class="quantity-offers__header">
      <div class="quantity-offers__heading">
        <div class="quantity-offers__icon">
          <v-icon color="primary" size="26">mdi-sale</v-icon>
        </div>
        <div>
          <h1 class="quantity-offers__title my-0">Quantity discounts</h1>
          <p class="quantity-offers__subtitle mb-0">
            Offer customers to buy in a bulk of products with your attractive discount.
          </p>
        </div>
      </div>
      <v-btn color="primary" depressed class="quantity-offers__create" @click="goToCreate">
        <v-icon left size="20">mdi-plus</v-icon> Create offer
      </v-btn>
    </div>
    <Offer />
  </div>
</template>

<script>
import Offer from './components/Offer';
export default {
  components: {
    Offer,
  },
  methods: {
    goToCreate() {
      this.$router.push({ name: 'website.apps.quantity.create' });
    },
  },
};
</script>

<style lang="scss" scoped>
.quantity-offers {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
  }
  &__heading {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #eef4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  &__title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
    color: #1f2937;
  }
  &__subtitle {
    margin-top: 4px;
    font-size: 14px;
    color: #6b7280;
    max-width: 560px;
  }
  &__create {
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
    border-radius: 8px;
    height: 44px;
  }
}
</style>
